module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lDXp2"))).then(() => parcelRequire('dJXJK'));